import angular from 'angular'

import areaCtrl from './area.controller'
import areaRoutes from './area.routes'
import areaRun from './area.run'

const name = 'routingConsultArea'

angular.module(name, [])
  .controller('areaCtrl', areaCtrl)
  .config(areaRoutes)
  .run(areaRun)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/area/area.module.js